const split = require('./lib/split'),
      join  = require('./lib/join');

module.exports = { split, join };